export const getLogoContainerStyle = () => ({
  display: "flex",
  width: "11%",
  marginRight: "64px",
  cursor: "pointer",
  borderStyle: "none",
  background: "transparent",
});
